import produce from 'immer';
import { put, takeLatest, delay } from 'redux-saga/effects';
import {
    creator,
    errorMessageGenerator,
    serialize as serializeToQueryString
} from 'uwork-app-core';
import axios from 'utils/axios';

/**
 * Constants
 */
export const REQUEST = '@app/workers/companysearchworkerssaga/REQUEST';
export const SUCCESS = '@app/workers/companysearchworkerssaga/SUCCESS';
export const FAILURE = '@app/workers/companysearchworkerssaga/FAILURE';
export const CLEAR = '@app/workers/companysearchworkerssaga/CLEAR';

/**
 * Initial state
 */
const initState = {
    items: []
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case SUCCESS:
                draft.items = payload;
                break;
            case FAILURE:
                draft.errorStatus = payload;
                break;
            case CLEAR:
                draft.items = [];
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Selectors
 */

/**
 * Redux actions
 */
export const actions = {
    request: (data) => creator(REQUEST, data),
    success: (data) => creator(SUCCESS, data),
    failure: (data) => creator(FAILURE, data),
    clear: () => creator(CLEAR)
};

/**
 * Sagas
 */
export const sagas = {
    *request({ payload }) {
        try {
            yield delay(200, true);
            const queryString = serializeToQueryString(payload, true);
            const response = yield axios.get(`/workers?${queryString}`);
            yield put(actions.success(response.data));
        } catch (e) {
            console.error(e);
            const error = errorMessageGenerator(e);
            yield put(creator(CLEAR));
            yield put(actions.failure(error));
        }
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.request);
};
